// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"styles_submitButton__3rW5m","cancelButton":"styles_cancelButton__3F3gG"};